import { createContext, useContext } from 'react';
import { initialState } from './Modals.constants';
import { tModalsContext } from './Modals.types';

export const ModalsContext = createContext<tModalsContext>(initialState);

export const useModalsContext = (): tModalsContext => useContext(ModalsContext);
